import { z } from '@harvestiq/zod';
import { zDecimalRequired } from '@harvestiq/zod';
import {
  LivestockInsuranceTypes,
  RmaLgmCommodityCodes,
  RmaLrpCommodityCodes,
} from '@harvestiq/constants';
import { zIsoDate } from '@harvestiq/zod';

export const lgmMarketingsSchema = z.object({
  grossMarginGuarantee: zDecimalRequired(),
  numberOfHead: z.number(),
  formattedMarketingMonth: z.string(), // formatted month and year, eg. July 2024
});

const commonSchema = {
  commodityType: z.string(),
  endDate: zIsoDate().nullable(), // null for LGM
  insuredName: z.string(),
  salesEffectiveDate: zIsoDate(),
  isPre2026BeginningFarmerRancher: z.boolean().optional(),
  isVeteranFarmerRancher: z.boolean().optional(),
  beginningFarmerRancherCropYearCount: z.number().int().nullable().optional(),
};

export const lrpCoverageTableSchema = z.object({
  type: z.literal(LivestockInsuranceTypes.LRP),
  commodityCode: z.nativeEnum(RmaLrpCommodityCodes),
  coverageLevel: z.number(),
  coveragePricePerCwt: z.number(),
  coveragePricePerHead: z.number(),
  targetWeight: z.coerce.number(),
  endorsementLength: z.number(),
  numberOfHead: z.coerce.number(),
  ...commonSchema,
});

export const lgmCoverageTableSchema = z.object({
  type: z.literal(LivestockInsuranceTypes.LGM),
  commodityCode: z.nativeEnum(RmaLgmCommodityCodes),
  deductible: z.number(),
  liveCattleTargetCwtPerHead: z.number().nullable(),
  feederCattleTargetCwtPerHead: z.number().nullable(),
  cornTargetBuPerHead: z.number().nullable(),
  marketingMonths: z.array(lgmMarketingsSchema),
  ...commonSchema,
});

export const coverageDetailsEmailTableSchema = z.discriminatedUnion('type', [
  lrpCoverageTableSchema,
  lgmCoverageTableSchema,
]);
export type CoverageDetailsEmailTable = z.infer<
  typeof coverageDetailsEmailTableSchema
>;
